import React, { Component } from 'react';
import { Cell, FontIcon, Grid } from 'react-md';
import { trackEvent } from '../../util/analytics';
import './Summary.scss';

class Summary extends Component {
  handleClick = () => {
    const { app_url } = this.props.bundleSummary;
    if (!app_url) {
      window.open('https://www.datatheorem.com/about/contact/', '_blank');
    }

    window.open(app_url, '_blank');
    trackEvent({
      category: 'External',
      action: 'Bundle Clicked',
    });
  };

  render() {
    const {
      platform,
      company,
      app_name: name,
      bundle_id: bundle,
    } = this.props.bundleSummary;

    const platformLabel = platform === 1 ? 'iOS' : 'Android';

    return (
      <div className="summary-wrapper">
        <Grid>
          <Cell size={8} className="summary-cell">
            <h1 className="company-name">{company}</h1>
          </Cell>
          <Cell size={4} className="bundle-cell">
            <h4
              className="app-name"
              onClick={this.handleClick}
              onKeyPress={this.handleClick}
            >
              <FontIcon className="icon-proper">link</FontIcon>
              &nbsp;{name}
            </h4>
            <h4 className="bundle-summary">
              {platformLabel} app: {bundle}
            </h4>
          </Cell>
        </Grid>
      </div>
    );
  }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/components/Summary/Summary.jsx